import get from 'lodash/get';
import { ref, computed } from 'vue';
import { useEscapeStack } from '/app/composables/escape-stack';

export const useFloating = () => {
	const target = ref(null);
	const popper = computed(() => {
		return get(target, 'value.$refs.popper', {
			show: () => {},
			hide: () => {},
		});
	});
    const showing = computed(() => {
        return popper.value.isShown;
    });

    const show = () => popper.value.show();
    const hide = () => popper.value.hide();

    useEscapeStack(showing, hide);

    return {
        target,
        showing,
        show,
        hide,
    }
};

